import TableCells from 'components/TableCells';
import { ParsedPlayStats } from 'pages/Play/types';

import { Column } from 'react-table';
import { sorters } from 'utils/table';

export const defaultSort = [{ id: 'date', desc: false }];

export const columns: ReadonlyArray<Column<ParsedPlayStats>> = [
  {
    Footer: 'Totals',
    Header: 'Date',
    accessor: 'date',
    sortType: sorters.sortByDate('date'),
  },

  {
    Cell: TableCells.NumericCell,
    Footer: (info) => (
      <TableCells.SummedNumericCell columnName="plays" tableData={info} />
    ),
    Header: <TableCells.HeaderCell accessor="plays" />,
    accessor: 'plays',
    sortType: 'number',
  },
];
